export default "__VITE_ASSET__b2d5e802__"